{
  "pages": {
    "dashboard": {
      "greeting": {
        "morning": "좋은 아침입니다",
        "afternoon": "안녕하세요",
        "evening": "안녕하세요"
      },
      "header": {
        "fallbackUser": "사용자",
        "facility": "시설 {{id}}"
      },
      "criticalBanner": {
        "message_one": "확인이 필요한 중요 결과 {{count}}건",
        "message_other": "확인이 필요한 중요 결과 {{count}}건",
        "reviewNow": "지금 확인"
      },
      "sections": {
        "overview": "개요",
        "tasks": "작업",
        "myPatients": "내 환자",
        "recentActivity": "최근 활동",
        "quickActions": "빠른 작업"
      },
      "stats": {
        "activeEncounters": "진행 중인 진료",
        "pendingOrders": "대기 중인 처방",
        "resultsToReview": "검토 대기 결과",
        "criticalAlerts": "중요 알림"
      },
      "tasks": {
        "unsignedNotes": "미서명 노트",
        "criticalResultsPending": "확인 대기 중인 중요 결과",
        "cosignaturesNeeded": "공동 서명 필요",
        "ordersToReview": "검토할 처방",
        "activeMedications": "진행 중인 약물",
        "admissionsPending": "입원 대기",
        "ordersToVerify": "약사 확인 대기 처방",
        "controlledSubstanceReviews": "마약류 확인",
        "systemAlerts": "시스템 알림",
        "systemStatus": "시스템 상태"
      },
      "systemStatusValue": {
        "healthy": "정상"
      },
      "empty": {
        "noPatients": "배정된 활동 환자가 없습니다.",
        "noTasks": "역할별 작업이 없습니다.",
        "noRecentEncounters": "최근 진료 기록이 없습니다."
      },
      "quickActions": {
        "findPatient": {
          "label": "환자 찾기",
          "description": "기록 검색"
        },
        "registerPatient": {
          "label": "환자 등록",
          "description": "신규 환자 추가"
        },
        "viewCensus": {
          "label": "재원 환자 보기",
          "description": "진행 중인 진료"
        },
        "reports": {
          "label": "보고서",
          "description": "분석 보기"
        }
      },
      "viewAll": "모두 보기",
      "bedLabel": "병상 {{n}}",
      "admittedLabel": "입원일 {{date}}",
      "fallback": {
        "unknownPatient": "알 수 없는 환자",
        "unknownType": "알 수 없음"
      },
      "acuity": {
        "1": "소생",
        "2": "긴급",
        "3": "준긴급",
        "4": "준응급",
        "5": "비응급"
      },
      "encounterType": {
        "emergency": "응급",
        "inpatient": "입원",
        "outpatient": "외래",
        "observation": "관찰"
      },
      "encounterStatus": {
        "active": "진행 중",
        "completed": "완료",
        "discharged": "퇴원",
        "cancelled": "취소됨",
        "pending": "대기 중"
      }
    },
    "qualityMeasures": {
      "title": "품질 지표",
      "subtitle": "임상 품질 지표 및 규제 준수 현황을 추적합니다",
      "refresh": "새로 고침",
      "allTypesLabel": "모든 유형",
      "allFacilitiesLabel": "모든 시설",
      "targetPrefix": "목표: {{value}} {{unit}}",
      "updatedPrefix": "업데이트: {{value}}",
      "measureType": {
        "process": "프로세스",
        "outcome": "결과",
        "structure": "구조"
      },
      "summary": {
        "totalMeasures": "전체 지표",
        "meetingTarget": "목표 달성",
        "belowTarget": "목표 미달"
      },
      "toasts": {
        "refreshSuccess": "지표가 새로 고쳐졌습니다"
      },
      "results": {
        "title": "기록된 결과",
        "period": "기간",
        "facility": "시설",
        "denominator": "분모",
        "numerator": "분자",
        "exclusions": "제외",
        "rate": "비율",
        "source": "출처",
        "calculated": "계산일",
        "empty": "이 기간에 이 지표의 기록된 결과가 없습니다.",
        "loadError": "기록된 결과를 불러오지 못했습니다.",
        "allFacilities": "모든 시설",
        "record": "결과 기록"
      },
      "sources": {
        "manual": "수동",
        "sql-template": "SQL 템플릿",
        "import": "가져오기"
      },
      "qrda": {
        "download": "QRDA III",
        "measureDownload": "QRDA",
        "success": "QRDA 보고서를 다운로드했습니다",
        "error": "QRDA 다운로드 실패"
      },
      "record": {
        "title": "질 지표 결과 기록",
        "titleFor": "결과 기록 — {{code}} {{name}}",
        "subtitle": "기록된 결과는 지표 기록에 표시되고 QRDA 범주 III 내보내기에 반영됩니다. 같은 기간을 다시 기록하면 이전 행이 대체됩니다.",
        "back": "질 지표로 돌아가기",
        "cancel": "취소",
        "save": "결과 기록",
        "measureNotFound": "지표를 찾을 수 없습니다. 비활성화되었을 수 있습니다.",
        "fields": {
          "periodStart": "기간 시작",
          "periodEnd": "기간 종료",
          "facility": "시설",
          "allFacilities": "모든 시설",
          "denominator": "분모",
          "numerator": "분자",
          "exclusions": "제외",
          "source": "산출 출처",
          "completeness": "데이터 완전성",
          "completenessHint": "데이터가 완전한 대상 레코드의 비율(0~1)입니다. 알 수 없으면 비워 두세요.",
          "notes": "비고"
        },
        "errors": {
          "periodStartRequired": "기간 시작은 필수입니다",
          "periodEndRequired": "기간 종료는 필수입니다",
          "periodOrder": "기간 종료는 기간 시작과 같거나 이후여야 합니다",
          "countInvalid": "0 이상의 정수를 입력하세요",
          "numeratorExceeds": "분자는 분모를 초과할 수 없습니다",
          "numeratorExceedsNet": "분자는 분모에서 제외를 뺀 값을 초과할 수 없습니다",
          "sourceRequired": "산출 출처는 필수입니다",
          "completenessRange": "완전성은 0에서 1 사이여야 합니다"
        },
        "toast": {
          "success": "결과가 기록되었습니다",
          "error": "기록에 실패했습니다"
        }
      }
    },
    "analyticsDashboard": {
      "title": "분석 대시보드",
      "subtitle": "병원 운영 지표 및 추이",
      "refresh": "새로 고침",
      "changeVsPrevPeriod": "이전 대비 {{sign}}{{value}}%",
      "dateRange": {
        "today": "오늘",
        "7d": "최근 7일",
        "30d": "최근 30일",
        "90d": "최근 90일"
      },
      "facility": {
        "all": "모든 시설",
        "sgh": "SGH - 싱가포르 종합병원",
        "nuh": "NUH - 싱가포르 국립대학교 병원",
        "ttsh": "TTSH - 탄톡셍 병원"
      },
      "department": {
        "all": "모든 부서",
        "er": "응급실",
        "icu": "중환자실",
        "medsurg": "내과·외과",
        "peds": "소아과",
        "maternity": "산과"
      },
      "widget": {
        "census": {
          "title": "현재 재원 인원"
        },
        "bedOccupancy": {
          "title": "병상 점유율"
        },
        "avgLOS": {
          "title": "평균 재원 일수"
        },
        "throughput": {
          "title": "총 진료 건수"
        },
        "readmission": {
          "title": "대기 중인 오더"
        }
      },
      "unit": {
        "patients": "명",
        "days": "일",
        "encounters": "건",
        "orders": "건"
      },
      "charts": {
        "admissionsVsDischarges": "입원 vs 퇴원",
        "admissionsByDepartment": "부서별 입원",
        "encounterTypes": "진료 유형",
        "censusTrend": "재원 인원 추이",
        "insufficientData": "차트를 표시하기에 데이터가 부족합니다",
        "insufficientTrendData": "추이 차트를 표시하기에 데이터가 부족합니다"
      },
      "series": {
        "admissions": "입원",
        "discharges": "퇴원",
        "census": "재원 인원"
      },
      "toasts": {
        "refreshSuccess": "대시보드가 새로 고쳐졌습니다"
      }
    },
    "reportRunner": {
      "title": "보고서 실행",
      "subtitle": "임상·재무·운영 보고서를 생성하고 내보냅니다",
      "scheduleButton": "보고서 예약",
      "searchPlaceholder": "보고서 검색...",
      "allCategoriesLabel": "전체 보고서",
      "category": {
        "clinical": "임상",
        "financial": "재무",
        "operational": "운영",
        "quality": "품질"
      },
      "emptyState": {
        "title": "시작하려면 보고서를 선택하세요",
        "subtitle": "왼쪽 보고서 목록에서 선택하세요"
      },
      "noResults": "필터에 일치하는 보고서가 없습니다",
      "parametersHeading": "매개변수",
      "selectOptionPlaceholder": "선택...",
      "runButton": "보고서 실행",
      "runningReport": "보고서 실행 중...",
      "exportCsv": "CSV",
      "exportPdf": "PDF",
      "format": {
        "csv": "CSV",
        "pdf": "PDF"
      },
      "columnLabel": {
        "facilityLocalDate": "날짜(시설 현지 시간)",
        "facilityTimeZone": "시설 시간대",
        "encounterDate": "날짜(UTC)"
      },
      "resultSummary": {
        "rows": "총 {{total}}행 중 {{shown}}행 표시",
        "executed": "실행 시간 {{ms}}ms"
      },
      "toasts": {
        "success": "보고서가 완료되었습니다 ({{executionTimeMs}}ms, {{rowCount}}행)",
        "failed": "보고서 실행에 실패했습니다",
        "missingFields": "필수 항목을 입력하세요: {{missingFields}}",
        "exporting": "{{format}}(으)로 내보내는 중...(자리표시자)",
        "scheduledPlaceholder": "예약 보고서 설정(자리표시자)"
      }
    }
  }
}
